import { render, staticRenderFns } from "./SoliAvatarBtn.vue?vue&type=template&id=db774124&scoped=true"
import script from "./SoliAvatarBtn.vue?vue&type=script&lang=js"
export * from "./SoliAvatarBtn.vue?vue&type=script&lang=js"
import style0 from "./SoliAvatarBtn.vue?vue&type=style&index=0&id=db774124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db774124",
  null
  
)

export default component.exports